module.exports = __webpack_public_path__ + "static/first-4d1857a9c64c9280e042b35e209279e3.png";